module.exports = __webpack_public_path__ + "static/img/gcgl_p1.66e69b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/gcgl_p1.png
// module id = gZpJ
// module chunks = 19